export const InversionShader = {

	uniforms: {

		'tDiffuse': { value: null },
		'invert': { value: false }

	},

	vertexShader: /* glsl */`
		varying vec2 vUv;
		void main() {
			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
		}`,

	fragmentShader: /* glsl */`
		uniform bool invert;
		uniform sampler2D tDiffuse;
		varying vec2 vUv;
		void main() {
			vec4 texel = texture2D( tDiffuse, vUv );
			if (invert) {
				vec3 invertedRgb =  vec3(1., 1., 1.) - texel.rgb;
				gl_FragColor = vec4(invertedRgb, texel.a);
			} else {
				gl_FragColor = texel;
			}
		}`

};
